import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import useWindowSize from '@Hooks/useWindowSize';

const PANEL_ID = 'poster-editor-fancy-text-fonts-panel';

export default function PosterEditorFancyTextFontsModal(): ReactElement<any> {
  const {windowHeight} = useWindowSize();
  const height = `${windowHeight / 2}px`;
  const maxWidth = '800px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_FANCY_TEXT_FONT_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      doesBottomSheetHaveSnapPoints
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="poster-editor-fancy-text-fonts-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorFancyTextFontsModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_FANCY_TEXT_FONT_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
